import { render, staticRenderFns } from "./ObiTitle.vue?vue&type=template&id=4017b4c0&scoped=true&"
import script from "./ObiTitle.vue?vue&type=script&lang=js&"
export * from "./ObiTitle.vue?vue&type=script&lang=js&"
import style0 from "./ObiTitle.vue?vue&type=style&index=0&id=4017b4c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4017b4c0",
  null
  
)

export default component.exports